import { Avatar, Grid, Stack, Typography } from '@mui/material';
import { IPrescriptionsOrders, IPresTruncatedDataDTO } from 'API';
import { BigButton } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Fragment, useState } from 'react';
import { PrescriptionsListItemMobile } from './PrescriptionsListItemMobile';
import { PrescriptionsListItemDesktop } from './PrescriptionsListItemDesktop';
import { sendEvent } from 'Utils/sendEvent';

interface IPrescriptionsListProps {
  titles: string[];
  items: IPrescriptionsOrders;
  onShowPrescriptionDetailsClick: (
    clickedPrescription: IPresTruncatedDataDTO
  ) => void;
}

const initialItemsToDisplay = 8;

export const PrescriptionsList = (props: IPrescriptionsListProps) => {
  const isDesktop = useIsDesktop();

  const allOrders = props.items.prescriptions;

  allOrders &&
    allOrders.sort(
      (a, b) =>
        new Date(b.createDate).getTime() - new Date(a.createDate).getTime()
    );

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  const [itemsAmountToDisplay, setItemsAmountToDisplay] = useState({
    itemsToDisplay: initialItemsToDisplay,
    text: dictionary.toAllPrescriptions,
  });

  const showAllItems = () => {
    isDesktop && sendEvent('Medicine', 'AllStatusOrder');
    setItemsAmountToDisplay((prevState) => {
      let itemsToDisplay;
      let text;
      if (prevState.itemsToDisplay === initialItemsToDisplay) {
        itemsToDisplay = allOrders.length;
        text = dictionary.seeLess;
      } else {
        itemsToDisplay = initialItemsToDisplay;
        text = dictionary.toAllPrescriptions;
      }
      return {
        itemsToDisplay,
        text,
      };
    });
  };

  return (
    <>
      <Grid
        container
        rowSpacing={0}
        columnSpacing={0}
        mb={isDesktop ? '40px' : '104px'}
      >
        <Grid
          component={'ul'}
          padding={0}
          container
          item
          xs={12}
          gap={2}
          justifyContent={isDesktop ? 'start' : 'center'}
          sx={{ width: '100%', mb: '40px', bgcolor: 'transparent' }}
        >
          {allOrders &&
            allOrders.map((item, index) => {
              if (index < itemsAmountToDisplay.itemsToDisplay) {
                if (!isDesktop) {
                  return (
                    <PrescriptionsListItemMobile
                      key={index}
                      titles={props.titles}
                      item={item}
                      onShowPrescriptionDetailsClick={
                        props.onShowPrescriptionDetailsClick
                      }
                      itemRecordStatus={item.currentStatusLabel || ''}
                    />
                  );
                } else {
                  return (
                    <PrescriptionsListItemDesktop
                      key={index}
                      item={item}
                      onShowPrescriptionDetailsClick={
                        props.onShowPrescriptionDetailsClick
                      }
                      itemRecordStatus={item.currentStatusLabel || ''}
                      titles={props.titles}
                    />
                  );
                }
              } else return <Fragment key={index}></Fragment>;
            })}
        </Grid>
      </Grid>
      {allOrders && itemsAmountToDisplay.itemsToDisplay < allOrders.length && (
        <Stack
          onKeyUp={(e: React.KeyboardEvent) => {
            e.key === 'Enter' && showAllItems();
          }}
          tabIndex={0}
          onClick={showAllItems}
          direction={'row'}
          spacing={1}
          sx={{
            width: 'fit-content',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            m: isDesktop ? '10px auto' : undefined,
          }}
          role='button'
        >
          <Typography variant='body5' color={'primary'}>
            {itemsAmountToDisplay.text}
          </Typography>
          <Avatar
            src={BigButton}
            alt=''
            sx={{
              width: '46px',
              height: '50px',
              transform: 'rotate(270deg)',
            }}
          />
        </Stack>
      )}
    </>
  );
};
